export default class BaseSwitcher {
    static init(): void {
         // Najdeme všechny switcher komponenty na stránce
        const switchers: NodeListOf<Element> = document.querySelectorAll('.js-base-switcher');

        switchers.forEach((switcher: Element) => {
            // Najdeme všechny trigger tlačítka v rámci tohoto switcheru
            const triggers: NodeListOf<Element> = switcher.querySelectorAll('[data-switcher-trigger]');
            const contents: NodeListOf<Element> = switcher.querySelectorAll('[data-switcher-content]');

            // Přidáme event listener na každé trigger tlačítko
            triggers.forEach((trigger: Element) => {
                trigger.addEventListener('click', (e: Event) => {
                    e.preventDefault();

                    // Získáme ID obsahu, který má být zobrazen
                    const targetId: string | null = trigger.getAttribute('data-switcher-trigger');

                    if (!targetId) return;

                    // Odebereme is-active třídu ze všech triggers a contents
                    triggers.forEach((t: Element) => {
                        t.classList.remove('is-active');
                    });

                    contents.forEach((c: Element) => {
                        c.classList.remove('is-active');
                    });

                    // Přidáme is-active třídu na aktuální trigger
                    trigger.classList.add('is-active');

                    // Najdeme a zobrazíme odpovídající content
                    const targetContent: Element | null = switcher.querySelector(`[data-switcher-content="${targetId}"]`);
                    if (targetContent) {
                        targetContent.classList.add('is-active');
                    }
                });
            });
        });
    }
}
